import { PropsWithChildren } from "react";

type HelptextProps = PropsWithChildren<{ className?: string }>;

export function Helptext({ className, children }: HelptextProps) {
    return <tractie-helptext className={className}>{children}</tractie-helptext>;
}
